module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Medium Gray - Selected.ff13ddd0.png";